import React from 'react';
import Button from 'devextreme-react/button';
import { SPSyncGrantResult, SPSyncResult, SPSyncRow } from '../../../api/v2/SPSyncApi';
import SPSyncSummaryBar from './SPSyncSummaryBar';
import SPSyncTreeList from './SPSyncTreeList';

interface SPSyncDetailViewProps {
    grantResult: SPSyncGrantResult | null;
    result: SPSyncResult | null;
    loading: boolean;
    showOnlyDiffs: boolean;
    setShowOnlyDiffs: (val: boolean) => void;
    filteredRows: SPSyncRow[];
    reload: () => void;
}

const SPSyncDetailView: React.FC<SPSyncDetailViewProps> = ({
    grantResult, result, loading,
    showOnlyDiffs, setShowOnlyDiffs,
    filteredRows, reload
}) => {
    if (loading) {
        return (
            <div className="container-fluid" style={{ padding: '20px' }}>
                <h4>Loading reconciliation...</h4>
            </div>
        );
    }

    if (!grantResult) {
        return (
            <div className="container-fluid" style={{ padding: '20px' }}>
                <h4>Grant not found</h4>
            </div>
        );
    }

    return (
        <div className="container-fluid" style={{ padding: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '5px' }}>
                <Button
                    icon="back"
                    type="normal"
                    stylingMode="text"
                    onClick={() => window.history.back()}
                />
                <h4 style={{ margin: 0 }}>
                    {grantResult.grantNumber} - {grantResult.institution} - FY {grantResult.fy}
                </h4>
            </div>

            {result && (
                <>
                    <SPSyncSummaryBar result={result} showOnlyDiffs={showOnlyDiffs} setShowOnlyDiffs={setShowOnlyDiffs}>
                        <Button
                            icon="refresh"
                            text="Reload"
                            type="normal"
                            stylingMode="outlined"
                            onClick={reload}
                        />
                    </SPSyncSummaryBar>

                    {result.errors.length > 0 && (
                        <div style={{ color: 'red', marginBottom: '10px', border: '1px solid #dc3545', padding: '8px', borderRadius: '4px' }}>
                            <strong>Errors:</strong>
                            <ul style={{ margin: '4px 0 0 0' }}>{result.errors.map((e, i) => <li key={i}>{e}</li>)}</ul>
                        </div>
                    )}

                    <SPSyncTreeList rows={filteredRows} />
                </>
            )}
        </div>
    );
};

export default SPSyncDetailView;
